import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { m } from 'framer-motion';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import Image from '../../components/Image';
import Iconify from '../../components/Iconify';
import useAuth from '../../hooks/useAuth';
import { useDispatch } from '../../redux/store';
import { openLoginSignup } from '../../redux/slices/authPages';
import conObj from '../../utils/connection-assistant';
import { useLangNavigate } from '../../hooks/useLangNavigate';
import useLocales from '../../hooks/useLocales';

const width = window.innerWidth;
const height = window.innerHeight;
const CheckDayImage = (props) => {
  const { translate } = useLocales();
  const dailyImageList = !props.is_done
    ? require(`../../assets/spin/checkin/Day.png`)
    : require(`../../assets/spin/checkin/DayDone.png`);

  const seventhday = !props.is_done
    ? require(`../../assets/spin/checkin/DaySeven.png`)
    : require(`../../assets/spin/checkin/DaySevenDone.png`);

  const filterBackgroundImage = useMemo(() => (props.dayNo === 7 ? seventhday : dailyImageList), [props]);
  return (
    <Box
      sx={{
        backgroundImage: `url(${filterBackgroundImage})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        height: props.dayNo === 7 ? '100%' : { md: '100px', sm: '18vw', xs: '18vw' },
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: props.is_today ? `rgba(255, 215, 0) 0px 0px 5px 2px` : 'none',
        borderRadius: { sm: '20px', xs: '16px' },
        border: `4px solid rgba(255, 215, 0, ${props.is_today ? '1' : '0'})`,
        position: 'relative',
      }}
    >
      <Typography
        fontWeight={900}
        sx={{
          fontSize: { md: '1.6rem', sm: '1.3rem', xs: '1.2rem' },
          color: '#ff0000',
          textTransform: 'uppercase',
          WebkitTextStroke: '2px #ffe816ff',
          paintOrder: 'stroke fill',
          letterSpacing: '0.02em',
          lineHeight: 1,

          filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3))',
        }}
      >
        +{props.bonus}
      </Typography>
      <Typography
        sx={{
          backgroundImage: `url(${require('../../assets/spin/checkin/DayText.png')})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          textAlign: 'center',
          fontWeight: 700,
          width: { md: '70px', sm: '60px', xs: '50px' },
          padding: '4px 0',
          fontSize: { md: '12px', sm: '10px', xs: '8px' },
          marginTop: '8px',
          marginBottom: { md: '-24px', sm: '-20px', xs: '-17px' },
        }}
      >
        {props.is_today ? translate('today') : `${translate('day_no')} ${props.dayNo}`}
      </Typography>
      {props.is_done && (
        <Image
          src={require('../../assets/spin/checkin/tick.png')}
          sx={{
            position: 'absolute',
            width: { xs: '6vw', sm: '40px' },
            height: { xs: '5vw', sm: '35px' },
            right: 0,
            bottom: { xs: '2vw', sm: '15px' },
          }}
        />
      )}
    </Box>
  );
};

CheckDayImage.propTypes = {
  dayNo: PropTypes.number.isRequired,
  is_done: PropTypes.bool.isRequired,
  is_today: PropTypes.bool.isRequired,
  bonus: PropTypes.any,
};
const DailyCheckInButton = ({ sx }) => {
  const { translate } = useLocales();

  const { enqueueSnackbar } = useSnackbar();

  const [isOpen, setIsOpen] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);

  const [dailyCheckIn, setDailyCheckIn] = useState([]);

  const [dailyCheckInSetting, setDailyCheckInSetting] = useState([]);

  const [dailyCheckInPromoId, setDailyCheckinPromoId] = useState(null);

  const [isToday, setIsToday] = useState(null);

  const [isExist, setIsExist] = useState(false);

  const { isAuthenticated } = useAuth();

  const dispatch = useDispatch();

  const navigate = useLangNavigate();

  const handleClick = () =>
    isAuthenticated ? navigate('/spin') : dispatch(openLoginSignup({ open: true, isLogin: true }));

  const getDailyCheckIn = async () => {
    try {
      const response = await conObj.post(`members/daily_deposit_check_in_promotion.json`);
      if (response.data.data.data) {
        setDailyCheckIn(response.data.data.data);

        setDailyCheckInSetting(response.data.data);

        const todayObj = Object.values(response.data.data.data).find((item) => item.is_today);

        setIsToday(todayObj);

        setOpenDialog(true);
      } else {
        const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
        enqueueSnackbar(translate('no_promotion'), snackbarOptions);
      }
    } catch (error) {
      const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
      enqueueSnackbar(error?.message, snackbarOptions);
    }
  };

  const navigateDeposit = useCallback(() => {
    setOpenDialog(false);
    navigate(`/user/wallet?select_promotion_id=${dailyCheckInSetting?.promotion_id}`);
    window.location.reload();
  }, [dailyCheckInSetting]);
  //   if (!isOpen || location.pathname !== '/') return <></>;
  return (
    <>
      <Box
        sx={{
          width: '80px',
          display: 'flex',
          alignItems: 'start',
          ...sx,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'fit-content',
            height: 'fit-content',
          }}
        >
          <Box onClick={() => getDailyCheckIn()} sx={{ cursor: 'pointer' }} component={m.div}>
            <Image src={require('../../assets/spin/dailcheckin.png')} />
          </Box>
        </Box>
        {/* <IconButton onClick={() => setOpenDialog(true)} sx={{ p: 0, m: 0, marginTop: '-15px', marginLeft: '-2px' }}>
          <Iconify icon="carbon:close-filled" sx={{ color: '#F0C335', fontSize: '20px' }} />
        </IconButton> */}
      </Box>

      <Dialog
        fullWidth
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
      >
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: { sm: 3, xs: 1 },
          }}
        >
          <Image src={require('../../assets/spin/dailychecinbg.png')} />
          <Container
            sx={{
              position: 'absolute',
              width: '85%',
              top: { xs: '30vw', sm: '190px' },
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Grid container>
              <Grid item xs={9}>
                <Grid container>
                  <Grid item xs={4}>
                    <CheckDayImage dayNo={1} {...dailyCheckIn[1]} />
                  </Grid>
                  <Grid item xs={4}>
                    <CheckDayImage dayNo={3} {...dailyCheckIn[3]} />
                  </Grid>
                  <Grid item xs={4}>
                    <CheckDayImage dayNo={5} {...dailyCheckIn[5]} />
                  </Grid>
                  <Grid item xs={4}>
                    <CheckDayImage dayNo={2} {...dailyCheckIn[2]} />
                  </Grid>
                  <Grid item xs={4}>
                    <CheckDayImage dayNo={4} {...dailyCheckIn[4]} />
                  </Grid>
                  <Grid item xs={4}>
                    <CheckDayImage dayNo={6} {...dailyCheckIn[6]} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={3}>
                <CheckDayImage dayNo={7} {...dailyCheckIn[7]} />
              </Grid>
            </Grid>
            {/* <Grid container spacing={1.4} justifyContent={'center'} rowGap={1} flexWrap={'nowrap'}>
              <Grid
                container
                sx={{
                  width: '65%',
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'nowrap',
                }}
              >
                <Grid item flexDirection={'column'}>
                  <Grid container wrap="nowrap" gap={0}>
                    <CheckDayImage dayNo={1} {...dailyCheckIn[1]} />
                    <CheckDayImage dayNo={3} {...dailyCheckIn[3]} />
                    <CheckDayImage dayNo={5} {...dailyCheckIn[5]} />
                  </Grid>
                  <Grid container wrap="nowrap">
                    <CheckDayImage dayNo={2} {...dailyCheckIn[2]} />
                    <CheckDayImage dayNo={4} {...dailyCheckIn[4]} />
                    <CheckDayImage dayNo={6} {...dailyCheckIn[6]} />
                  </Grid>
                </Grid>
                <Grid sx={{ width: '20%' }}>
                  <CheckDayImage dayNo={7} {...dailyCheckIn[7]} />
                </Grid>
              </Grid>
            </Grid> */}
          </Container>
        </DialogContent>
        {dailyCheckInSetting?.show_deposit_today_btn && (
          <DialogActions>
            <Button
              onClick={navigateDeposit}
              sx={{
                textAlign: 'center',
                width: '100%',
                backgroundColor: '#ffb90f',
                '&:hover': {
                  backgroundColor: '#16A150',
                },
              }}
            >
              {translate('earn_extra_x_today', { x: `${process.env.REACT_APP_CURRENCY_CODE}${isToday?.bonus}` })}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default DailyCheckInButton;
